import React, { useState, useEffect } from 'react';
import { Layout, Tabs, message } from 'antd';
import { 
  HomeOutlined, 
  FormOutlined, 
  StarOutlined, 
  BarChartOutlined,
  UserOutlined
} from '@ant-design/icons';
import PostEditor from './PostEditor';
import PostList from './PostList';
import RankingList from './RankingList';
import Profile from './Profile';
import ValueUserList from './ValueUserList';
import { CORP_ID } from '../config';
import { AuthProvider, useAuth } from '../stores/LoginFree';
import { API_BASE_URL } from '../config';

const { Header, Content, Footer } = Layout;
const { TabPane } = Tabs;

export default function AppContent() {
  const { accessToken, currentUser, outTrackId, actionId,u2 } = useAuth();
  const [posts, setPosts] = useState([]);
  const [userInfo, setUserInfo] = useState(null);
  const [activeTab, setActiveTab] = useState('list');
  const [selectedPostId, setSelectedPostId] = useState(null);
  const [autoLiked, setAutoLiked] = useState(false);
  const [userOptions, setUserOptions] = useState([]);//选择value的用户列表

  const fetchUserList = async () =>{
      const response = await fetch(`${API_BASE_URL}/dingtalk/getuserlist`, {
              method: 'GET',
              headers: {
              'Content-Type': 'application/json',
              },
          });
          const data = await response.json();
          setUserOptions(data);
    }
  const fetchData = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/database/search`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          outTrackId: outTrackId
        })
      });
      const data = await response.json();
      if(data.success){
        console.log("帖子总数据：",data);
        // setAutoLiked(false); // 重置自动点赞状态
        setPosts(data.data);
        if(data.vp_outTrackId_id){
          setSelectedPostId(data.vp_outTrackId_id.vp_id);
        }
      }
    } catch (error) {
      console.error('获取数据失败:', error);
    }
  };
  const detailData = async (u2) => {
    try {
      const response = await fetch(`${API_BASE_URL}/dingding_user/searchdetail`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userid: u2,
        })
      });
      const data = await response.json();
      if(data){
        setUserInfo({
          name: data.du_name,
          avatar: data.du_avatar,
          userid: data.du_userid
        });
      }
    } catch (error) {
      console.error('获取数据失败:', error);
    }
  };

  useEffect(() => {
      fetchData();
      fetchUserList();
  }, [outTrackId]);

  const [scrollToComments, setScrollToComments] = useState(false);

  useEffect(() => {
    if (selectedPostId && posts.length > 0 && !autoLiked && currentUser && actionId==="like") {
      setActiveTab('list');
      setScrollToComments(true);
      // 重置滚动状态，避免下次进入时再次滚动
      setTimeout(() => {
        setScrollToComments(false);
      }, 300);
      const targetPost = posts.find(post => post.vp_id === selectedPostId);
      if (targetPost) {
        handleLike(selectedPostId);
        setAutoLiked(true);
      }
    }else if(selectedPostId && posts.length > 0 && !autoLiked && currentUser && actionId==="comment"){
      setActiveTab('list');
      setScrollToComments(true);
      // 重置滚动状态，避免下次进入时再次滚动
      setTimeout(() => {
        setScrollToComments(false);
      }, 300);
      setAutoLiked(true);
    }
  }, [posts, selectedPostId, autoLiked, currentUser]);
  useEffect(() => {
    if(u2 &&actionId === "likehome"){
      setActiveTab('valueuser');
      detailData(u2);
    }else if(u2 && actionId === "home"){
      setActiveTab('valueuser');
      detailData(u2);
    }
  }, [u2]);

  const handlePostSubmit = async (content, title, syncToChat, selectedValuesall, selectedUsers, outTrackId) => {
    try {
      const postData = {
        title: title,
        content: content,
        author: currentUser,
        selectedValuesall: selectedValuesall || [],
        selectedUsers: selectedUsers || []
      };
      
      console.log("postData", postData);
      
      // 调用后端接口
      const response = await fetch(`${API_BASE_URL}/posts/insert`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          title: title,
          content: content,
          author: currentUser.userId,
          selectedValuesall: selectedValuesall || [],
          selectedUsers: selectedUsers || [],
          outTrackId: outTrackId || null
        })
      });
      const result = await response.json();
      if (result) {
        await fetchData();
      }else{
        message.error('发布失败,请联系技术部门小尹');
      }
    } catch (error) {
      console.error('发布失败:', error);
      message.error('发布失败，请稍后重试');
    }
  };

  const handleLike = async (postId) => {
  if (!currentUser) {
    console.error('User not logged in');
    return;
  }
  const response = await fetch(`${API_BASE_URL}/posts/likes`, {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            vl_type_id: postId,
            vl_du_id: currentUser.userId,

          })
        });
        console.log("查看点赞",response)
        await fetchData();
};

  const handlePostClick = (postId) => {
    setSelectedPostId(postId);
  };
 
  const handleBackToList = () => {
    setSelectedPostId(null);
  };

  return (
    <>
    {currentUser?.name==='测试用户' ? (
        <p>测试用户暂未开放功能</p>
        ) : (
    <Layout className="layout">
      <Header style={{ background: '#fff', padding: '0 20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
          <StarOutlined style={{ fontSize: '24px', color: '#1890ff', marginRight: '10px' }} />
          <h1 style={{ margin: 0, fontSize: '18px' }}>Value之星</h1>
        </div>
      </Header>
      <Content style={{ padding: '20px' }}>
          <Tabs activeKey={activeTab} onChange={setActiveTab}>
            <TabPane tab={<><FormOutlined /> 发布内容</>} key="editor">
              <PostEditor userOptions={userOptions} onSubmit={handlePostSubmit} corpId={CORP_ID} accessToken={accessToken} userInfo={currentUser} onRefresh={fetchData}/>
            </TabPane>
            <TabPane tab={<><HomeOutlined /> 帖子列表</>} key="list">
              <PostList selectedPostId={selectedPostId} posts={posts} currentUser={currentUser} onLike={handleLike} onPostClick={handlePostClick} onBack={handleBackToList} onRefresh={fetchData}  scrollToComments={scrollToComments}/>
            </TabPane>
            <TabPane tab={<><BarChartOutlined /> 排行榜</>} key="ranking">
              <RankingList />
            </TabPane>
            <TabPane tab={<><StarOutlined /> 我的主页</>} key="profile">
              <Profile selectedPostId={selectedPostId} onLike={handleLike} onBack={handleBackToList} scrollToComments={scrollToComments} user={currentUser} posts={posts.filter(post => post.userid === currentUser?.userId)} onRefresh={fetchData} onPostClick={handlePostClick}/>
            </TabPane>
            <TabPane tab={<><UserOutlined /> Ta的主页</>} key="valueuser">
              <ValueUserList actionId={actionId}selectedPostId={selectedPostId} u2={userInfo} onLike={handleLike} onBack={handleBackToList} scrollToComments={scrollToComments} user={currentUser} posts={posts} onRefresh={fetchData} onPostClick={handlePostClick} accessToken={accessToken}/>
            </TabPane>
          </Tabs>
      </Content>
      <Footer style={{ textAlign: 'center' }}>
        Value之星 ©{new Date().getFullYear()} 钉钉工作台应用
      </Footer>
    </Layout>
        )}
        </>
  );
}